import { render, staticRenderFns } from "./statistic-widget.vue?vue&type=template&id=6db2ff56&scoped=true"
import script from "./statistic-widget.vue?vue&type=script&lang=js"
export * from "./statistic-widget.vue?vue&type=script&lang=js"
import style0 from "./statistic-widget.vue?vue&type=style&index=0&id=6db2ff56&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db2ff56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db2ff56')) {
      api.createRecord('6db2ff56', component.options)
    } else {
      api.reload('6db2ff56', component.options)
    }
    module.hot.accept("./statistic-widget.vue?vue&type=template&id=6db2ff56&scoped=true", function () {
      api.rerender('6db2ff56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/chart-widget/statistic-widget.vue"
export default component.exports